import meilleurassu from '../images/origines/meilleurassu.svg';
import gads from '../images/origines/gads.svg';
import fb from '../images/origines/fb.svg';
import crm from '../images/origines/crm.png';
import inconnu from '../images/origines/inconnu.png';
import recyclage from '../images/recyclage.svg';
import comparadise from '../images/origines/comparadise.png';
import perseemedia from '../images/origines/perseemedia.png';
import lotuscale from '../images/origines/lotuscale.svg';



export const imagesorigine=(origine) =>{
    return origine ==="meilleureassurance.com"?meilleurassu:
            origine === "fb"?fb:
            origine === "gads"? gads :
            origine ===  "crm"?crm :
            origine ===  "comparadise"?comparadise :
            origine ===  "perseemedia"?perseemedia :
            origine ===  "lotuscale"?lotuscale :
            origine === "recyclage"?recyclage : inconnu}

export const champsgestion = {'gestion_remboursement' :  'Pour un remboursement en attente ou une demande de prise en charge'  , 
                                'gestion_impaye' :  'Pour une cotisation impayée',   
                                'gestion_questioncontrat' :  'Pour une question sur votre contrat',   
                                'gestion_changecontrat' :  'Pour changer de contrat',   
                                'gestion_parrainage' :  'Pour parrainer un ami',   
                                'gestion_autre' :  'Pour toute autre demande',   
                                'gestion_partenaire' :  'Vous êtes partenaire ou fournisseur',   
                                'gestion_redirectionleadnoseller' :  'Redirection nouveau lead non rattaché à un vendeur',   
                                'gestion_redirectionclientnoseller' :  'Redirection client dont le vendeur n’est pas identifié'}
                             
                


